import { observable, computed, action } from 'mobx'
import find from 'ramda/src/find'
import propEq from 'ramda/src/propEq'

// TODO COMPARE: delete this store and remove it from other files
class CreatorsComparisonStore {
  @observable
  creatorsComparison = []

  @observable
  shouldAddDefault = false

  @observable
  defaultCreatorInComparison = false

  @observable
  firstCreatorProvider = null

  @computed get comparisonMode() {
    return this.creatorsComparison.length > 0
  }

  @action setComparison(comparison) {
    this.creatorsComparison = comparison
  }

  @action addToComparison = creator => {
    if (this.creatorsComparison.length === 0) {
      this.firstCreatorProvider = creator.provider
    }

    if (
      this.defaultCreatorInComparison &&
      creator.id !== this.defaultCreatorInComparison.id &&
      !this.isCreatorInComparison(this.defaultCreatorInComparison) &&
      this.shouldAddDefault
    ) {
      return this.setComparison([...this.creatorsComparison, this.defaultCreatorInComparison, creator])
    }
    this.setComparison([...this.creatorsComparison, creator])
  }

  @action removeFromComparison = ({ id }) => {
    const newComparison = this.creatorsComparison.filter(creator => creator.id !== id)

    if (newComparison.length === 0) {
      this.firstCreatorProvider = null
    }

    return this.setComparison(newComparison)
  }

  @action isCreatorInComparison = ({ creatorId }) => !!find(propEq('id', creatorId))(this.creatorsComparison)

  @action handleSelect = ({ creator }) => {
    const shouldAddToComparison = !this.isCreatorInComparison({ creatorId: creator.id })
    shouldAddToComparison ? this.addToComparison(creator) : this.removeFromComparison(creator)
  }

  @action resetComparison = () => {
    this.firstCreatorProvider = null

    return (this.creatorsComparison = [])
  }

  @action makeComparisonPageUrl() {
    const qs = this.creatorsComparison.map(({ provider, id }) => `&creators=${provider}:${id}`).join('')
    return `/compare/creators?comparing=creators${qs}`
  }

  @action addDefaultCreatorInComparison = creator => {
    this.shouldAddDefault = !!creator
    if (creator) this.defaultCreatorInComparison = { ...creator, id: creator.creatorId }
    return
  }

  @action openComparisonOnNewTab = () => {
    if (!this.creatorsComparison.length) return
    const url = this.makeComparisonPageUrl()
    window.open(url, '_blank')
  }
}

export default new CreatorsComparisonStore()
